// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var OTPUtils = require("../../../../shared/src/OTPUtils.bs.js");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var DateUtils = require("../../../../shared/src/DateUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StringUtils = require("../../../../shared/src/StringUtils.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebGraphql_Signup = require("../../graphql/WebGraphql_Signup.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Selectors = require("../../store/WebStore_Selectors.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Input = require("../../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_Loading = require("../../../../shared-browser/src/components/BrowserComponents_Loading.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var WebComponents_BusinessUnauthenticatedScreen = require("../../components/WebComponents_BusinessUnauthenticatedScreen.bs.js");

var content = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: /* [] */0
      }
    });

var codeInputContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.rem(16.0)),
      tl: /* [] */0
    });

var codeInput = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* XXLarge */6, undefined)({
          hd: BrowserStyle.textAlign(BrowserStyle.center),
          tl: /* [] */0
        }));

var errorMessage = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Red */5,
            _0: /* Medium */2
          }),
      tl: {
        hd: BrowserStyle.textAlign(BrowserStyle.center),
        tl: /* [] */0
      }
    });

var resendButton = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Teal */6,
            _0: /* Medium */2
          }),
      tl: /* [] */0
    });

var Styles = {
  content: content,
  codeInputContainer: codeInputContainer,
  codeInput: codeInput,
  errorMessage: errorMessage,
  resendButton: resendButton
};

function waitingForCodeEntry(param_0) {
  return /* WaitingForCodeEntry */{
          _0: param_0
        };
}

function businessLoginOrSignup(code, phoneNumber) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$1 = Curry._1(WebGraphql_Signup.BusinessLoginOrSignUp.mutate, {
        phoneNumber: phoneNumber,
        code: code
      });
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$1, partial_arg, param);
  };
}

function finishSignup(businessName, city, code, email, firstName, finishLogin, lastName, password, phoneNumber, promoCode, utmParams, client) {
  return Relude_IO.flatMap(finishLogin, Relude_IO.flatMap((function (param) {
                    var jwt = param.jwt;
                    if (jwt !== undefined) {
                      return Relude_IO.pure(Caml_option.valFromOption(jwt));
                    }
                    var signupKey = param.signupKey;
                    if (signupKey !== undefined) {
                      return Curry._2(Relude_IO.mapError, (function (prim) {
                                    
                                  }), Curry._2(WebGraphql_Signup.SignupBusiness.mutate, {
                                      businessName: businessName,
                                      city: city,
                                      email: email,
                                      firstName: firstName,
                                      lastName: lastName,
                                      password: password,
                                      phoneNumber: phoneNumber,
                                      promoCode: promoCode,
                                      signupKey: Caml_option.valFromOption(signupKey),
                                      utmParams: utmParams
                                    }, client));
                    } else {
                      return Relude_IO.$$throw(undefined);
                    }
                  }), businessLoginOrSignup(code, phoneNumber)(client)));
}

function WebContainers_Signup_Business_VerifyCode$Presentation(Props) {
  var businessName = Props.businessName;
  var city = Props.city;
  var client = Props.client;
  var currentDatetime = Props.currentDatetime;
  var email = Props.email;
  var finishLogin = Props.finishLogin;
  var firstName = Props.firstName;
  var lastName = Props.lastName;
  var layout = Props.layout;
  var password = Props.password;
  var phoneNumber = Props.phoneNumber;
  var promoCode = Props.promoCode;
  var utmParams = Props.utmParams;
  var match = ReactIO.useState(function (param) {
        return /* SendingCode */0;
      });
  var setStatus = match[1];
  var status = match[0];
  var match$1 = ReactIO.useState(function (param) {
        return "";
      });
  var updateCodeEntry = match$1[1];
  var codeEntry = match$1[0];
  var updateCodeEntry$1 = function (param) {
    return Relude_Globals.$great$great(StringUtils.getNumbersOnly, updateCodeEntry, param);
  };
  var sendCode = Relude_IO.flatMap((function (param) {
          return Relude_Result.fold((function (param) {
                        if (param.message === "Invalid code. Please try again.") {
                          return Curry._1(setStatus, /* InvalidCodeError */3);
                        } else {
                          return Curry._1(setStatus, /* CouldNotSendCodeError */2);
                        }
                      }), (function (param) {
                        return Relude_IO.flatMap((function (param) {
                                      return Relude_Globals.$great$great(waitingForCodeEntry, setStatus, param);
                                    }), DateUtils.getNowInIO(undefined));
                      }), param);
        }), Relude_IO.flatMap((function (param) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Curry._2(WebGraphql_Signup.SendVerifyCode.mutateResult, phoneNumber, client));
            }), Relude_IO.flatMap((function (param) {
                  return Relude_Globals.$great$great(StringUtils.getNumbersOnly, updateCodeEntry, "");
                }), Curry._1(setStatus, /* SendingCode */0))));
  ReactIO.useHandledIOOnMount(undefined)(sendCode);
  var partial_arg = Relude_IO.pure(undefined);
  ReactIO.useEffect1(undefined, undefined, (function (param) {
          return Relude_Option.fold(partial_arg, (function (code) {
                        var partial_arg = Relude_IO.pure(undefined);
                        var arg = function (param) {
                          return Relude_AsyncResult.foldByValue(partial_arg, Relude_IO.pure, (function (param) {
                                        return Curry._1(setStatus, /* SignupError */4);
                                      }), param);
                        };
                        return IOUtils.ioWithStatus(undefined, arg, Relude_IO.flatMap((function (param) {
                                          return finishSignup(businessName, city, code, email, firstName, finishLogin, lastName, password, phoneNumber, promoCode, utmParams, client);
                                        }), Curry._1(setStatus, /* SigningUp */1)));
                      }), param);
        }), Curry._1(OTPUtils.OTP.fromString, codeEntry));
  var tmp;
  var exit = 0;
  if (typeof status === "number" && status === 1) {
    tmp = React.createElement(BrowserComponents_Loading.make, {});
  } else {
    exit = 1;
  }
  if (exit === 1) {
    var tmp$1;
    if (typeof status === "number") {
      switch (status) {
        case /* SendingCode */0 :
        case /* SigningUp */1 :
            tmp$1 = null;
            break;
        case /* CouldNotSendCodeError */2 :
            tmp$1 = React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                      size: /* XLarge */6
                    }), React.createElement(BrowserComponents_Text.make, {
                      className: errorMessage,
                      children: "Could Not Send Code"
                    }), React.createElement(BrowserComponents_Text.make, {
                      className: errorMessage,
                      children: "Please check the phone number you entered and try again. The phone number must be able to receive text messages."
                    }));
            break;
        case /* InvalidCodeError */3 :
            tmp$1 = React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                      size: /* XLarge */6
                    }), React.createElement(BrowserComponents_Text.make, {
                      className: errorMessage,
                      children: "Code Incorrect"
                    }), React.createElement(BrowserComponents_Text.make, {
                      className: errorMessage,
                      children: "Please enter the 4-digit code we sent to " + CommonTypes_LongPhoneNumber.toFormattedString(phoneNumber)
                    }));
            break;
        case /* SignupError */4 :
            tmp$1 = React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                      size: /* XLarge */6
                    }), React.createElement(BrowserComponents_Text.make, {
                      className: errorMessage,
                      children: "Could Not Signup - Unknown System Error"
                    }));
            break;
        
      }
    } else {
      var partial_arg$1 = 5;
      var arg = function (param, param$1, param$2, param$3) {
        return DateUtils.getDateWithAdjustedDuration(partial_arg$1, param, param$1, param$2, param$3);
      };
      tmp$1 = DateUtils.isLessThan(undefined, undefined, currentDatetime)(Curry._5(arg, undefined, undefined, undefined, undefined, status._0)) ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XLarge */6
                }), React.createElement(BrowserComponents_Button.Base.make, {
                  children: React.createElement(BrowserComponents_Text.make, {
                        children: "Resend Code"
                      }),
                  className: resendButton,
                  onClick: (function (param) {
                      return sendCode;
                    })
                })) : null;
    }
    tmp = React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_FlexColumn.make, {
              className: content,
              children: null
            }, React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(undefined)("oneTimeCode", true, codeInputContainer, undefined, undefined, undefined, undefined, undefined, codeInput, "numeric", undefined, undefined, undefined, undefined, undefined, undefined, /* Large */3, undefined, undefined, undefined, undefined, undefined, undefined, undefined), {
                      TAG: /* Text */7,
                      _0: {
                        onChange: updateCodeEntry$1,
                        value: codeEntry
                      }
                    }, undefined, undefined, undefined)), tmp$1));
  }
  return React.createElement(WebComponents_BusinessUnauthenticatedScreen.make, {
              buttonDisabled: true,
              buttonOnClick: Relude_IO.pure(undefined),
              buttonTitle: "Verify Phone Number",
              children: tmp,
              layout: layout,
              subtitle: typeof status === "number" ? (
                  status !== 1 ? (
                      status !== 0 ? "Enter the code we sent to " + (CommonTypes_LongPhoneNumber.toFormattedString(phoneNumber) + ".") : "We are sending a verification code to " + (CommonTypes_LongPhoneNumber.toFormattedString(phoneNumber) + "...")
                    ) : "Signing you up for the Qwick platform..."
                ) : "Enter the code we sent to " + (CommonTypes_LongPhoneNumber.toFormattedString(phoneNumber) + "."),
              title: "What's the code?"
            });
}

var Presentation = {
  Styles: Styles,
  sendingCode: /* SendingCode */0,
  waitingForCodeEntry: waitingForCodeEntry,
  signingUp: /* SigningUp */1,
  couldNotSendCodeError: /* CouldNotSendCodeError */2,
  invalidCodeError: /* InvalidCodeError */3,
  signupError: /* SignupError */4,
  businessLoginOrSignup: businessLoginOrSignup,
  finishSignup: finishSignup,
  make: WebContainers_Signup_Business_VerifyCode$Presentation
};

var mapStateToProps = Reselect.createSelector2(undefined, WebStore_Selectors.getApolloClient, (function (param) {
        return param.timing.currentDatetime;
      }), (function (client, currentDatetime) {
        return {
                client: client,
                currentDatetime: currentDatetime
              };
      }));

function mapDispatchToProps(dispatch) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$1 = {
    finishLogin: (function (param) {
        return Relude_Globals.$great$great((function (param) {
                      return Relude_Globals.$great$great(WebStore_Types_Action.finishLoginBusiness, dispatch, param);
                    }), partial_arg, param);
      })
  };
  return function (param) {
    return Relude_Globals.$$const(partial_arg$1, param);
  };
}

function WebContainers_Signup_Business_VerifyCode(Props) {
  var businessName = Props.businessName;
  var city = Props.city;
  var email = Props.email;
  var firstName = Props.firstName;
  var lastName = Props.lastName;
  var layout = Props.layout;
  var password = Props.password;
  var phoneNumber = Props.phoneNumber;
  var promoCode = Props.promoCode;
  var utmParams = Props.utmParams;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_Signup_Business_VerifyCode$Presentation, {
                              businessName: businessName,
                              city: city,
                              client: param.client,
                              currentDatetime: param.currentDatetime,
                              email: email,
                              finishLogin: param$1.finishLogin,
                              firstName: firstName,
                              lastName: lastName,
                              layout: layout,
                              password: password,
                              phoneNumber: phoneNumber,
                              promoCode: promoCode,
                              utmParams: utmParams
                            });
                })
            });
}

var make = WebContainers_Signup_Business_VerifyCode;

exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* content Not a pure module */
